import { LitElement, PropertyValueMap, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import '../single-select-item/single-select-item';

@customElement('single-select-list')
export class SingleSelectList extends LitElement {
  @property({ type: Array })
  items: Array<string> = [];

  @property({ type: Number })
  selectedIndex: number | null = null;

  override render() {
    if (this.items.length === 0) {
      return html`<div>No Items</div>`;
    } else {
      if (this.selectedIndex === null) {
        this.itemChanged(0);
      }

      return html`${this.items.map((item, index) => {
        return html`<single-select-item
          .text="${item}"
          ?selected="${this.selectedIndex === index}"
          @click="${() => this.itemChanged(index)}"
        ></single-select-item>`;
      })}`;
    }
  }

  protected override updated(
    _changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>,
  ): void {
    if (_changedProperties.has('items') && this.selectedIndex === null) {
      this.itemChanged(0);
    }
  }

  itemChanged(index: number) {
    this.selectedIndex = index;

    this.dispatchEvent(
      new CustomEvent('item-changed', {
        detail: {
          index: index,
        },
        bubbles: true,
        composed: true,
      }),
    );
  }
}
